import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = { source: string; id: string; headline: string; occurredAt: string };

export default function IntakesPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ intakes: Row[] }>("/api/v1/tenant/intakes/active");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("intakes.title")}</h1>
      <DataTable
        rows={data?.intakes ?? null}
        loading={loading}
        error={error}
        empty={t("intakes.empty")}
        columns={[
          { header: t("intakes.col.source"), render: (r) => r.source.replace("_", " ") },
          { header: t("intakes.col.headline"), render: (r) => r.headline },
          {
            header: t("intakes.col.when"),
            render: (r) => new Date(r.occurredAt).toLocaleString(),
          },
        ]}
      />
    </div>
  );
}
